'use strict';
angular.module('schoolLinqApp').factory('apSetupService', [
	'$http',
	function ($http) {
		var endpoint = '/api/accounts-payable-setup';

		function getAPSetup() {
			return $http.get(endpoint);
		}

		function saveAPSetup(apSetup) {
			return $http.put(endpoint, apSetup);
		}

		return {
			getAPSetup: getAPSetup,
			saveAPSetup: saveAPSetup,
		};
	},
]);
